import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/web-landing/layouts/default.vue").then(m => m.default || m))
}